import { render, staticRenderFns } from "./BaseSummaryInfo.vue?vue&type=template&id=a249df92&scoped=true"
import script from "./BaseSummaryInfo.vue?vue&type=script&lang=js"
export * from "./BaseSummaryInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseSummaryInfo.vue?vue&type=style&index=0&id=a249df92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a249df92",
  null
  
)

export default component.exports